export default __webpack_public_path__ + "static/media/offing-aruni-kashyap.5a32d614.webp";